export const REVIEW_SECTION_TYPES_FETCHED = 'REVIEW_SECTION_TYPES_FETCHED';
export const REVIEW_SECTION_TYPE_FETCHED = 'REVIEW_SECTION_TYPE_FETCHED';
export const REVIEW_SECTION_TYPE_ADD = 'REVIEW_SECTION_TYPE_ADD';
export const REVIEW_SECTION_TYPE_UPDATE = 'REVIEW_SECTION_TYPE_UPDATE';
export const REVIEW_SECTION_TYPE_REMOVE = 'REVIEW_SECTION_TYPE_REMOVE';
